import React, { createContext, useContext, useState, useCallback } from 'react'

const JumpLinksContext = createContext(null)

export const useJumpLinks = () => {
  const context = useContext(JumpLinksContext)
  if (!context) {
    // During build or if context is not available, return a no-op implementation
    return {
      jumpLinks: [],
      addJumpLink: () => {},
      clearJumpLinks: () => {},
    }
  }
  return context
}

export const JumpLinksProvider = ({ children }) => {
  const [jumpLinks, setJumpLinks] = useState([])

  const addJumpLink = useCallback((id, text) => {
    if (!id || !text) return

    setJumpLinks(prev => {
      // Avoid duplicates
      const exists = prev.some(link => link.id === id)
      if (exists) return prev

      return [...prev, { id, text }]
    })
  }, [])

  const clearJumpLinks = useCallback(() => {
    setJumpLinks([])
  }, [])

  const value = {
    jumpLinks,
    addJumpLink,
    clearJumpLinks,
  }

  return (
    <JumpLinksContext.Provider value={value}>
      {children}
    </JumpLinksContext.Provider>
  )
}
